import Head from 'next/head';

import AppleTouchIcon from '../../../../icons/site/apple-touch-icon.png';
import Favicon from '../../../../icons/site/favicon.ico';
import FaviconSVG from '../../../../icons/site/favicon.svg';

export function HTMLNoShellHead({ baseUrl }: { baseUrl: string }) {
	return (
		<Head>
			{baseUrl && <base href={`${baseUrl}/`} />}

			{/* Meta / SEO */}
			<meta charSet="utf-8" />
			<meta content="ie=edge" httpEquiv="x-ua-compatible" />

			{/* Favicons: https://evilmartians.com/chronicles/how-to-favicon-in-2021-six-files-that-fit-most-needs */}
			<link rel="icon" href={Favicon.src} sizes="32x32" />
			<link rel="icon" href={FaviconSVG.src} type="image/svg+xml" />
			<link rel="apple-touch-icon" href={AppleTouchIcon.src} />
		</Head>
	);
}
